<script lang="ts" setup>
const checkoutStore = useCheckoutStore();
const cartStore = useCartStore();
const { cart, selectedCartItems } = storeToRefs(cartStore);

const selectedItemsCountInCart = computed(() => {
  let count = 0;

  selectedCartItems.value.forEach((item) => {
    if (item.count) count += item.count;
  });

  return count;
});

const productsCountPluralized = computed(
  () => `${selectedItemsCountInCart.value} ${getNoun(selectedItemsCountInCart.value, 'товар', 'товара', 'товаров')}`,
);
const discountsList = computed(() => {
  if (cart.value.calculate.totalDiscounts) {
    return Object.values(cart.value.calculate.totalDiscounts);
  }
  return [];
});
const isShowDiscounts = ref(false);
const totalDiscountSum = computed(() => cart.value.calculate.price_without_discounts - cart.value.calculate.total);
const route = useRoute();
const totalSum = computed(() => {
  if (cart.value?.calculate) {
    if (route.name === 'cart') return cart.value.calculate.total;
    if (route.name === 'checkout') return cart.value.calculate.total + checkoutStore.deliveryCost;
  }
  return 0;
});
</script>

<template>
  <div
    v-if="selectedItemsCountInCart > 0"
    class="flex flex-col gap-3"
  >
    <div class="flex justify-between">
      <div>{{ productsCountPluralized }} на сумму</div>
      <div class="filler-underline" />
      <div>{{ cart.calculate.price_without_discounts }} ₽</div>
    </div>

    <div
      v-if="discountsList.length"
      class="flex flex-col w-full"
    >
      <button
        class="flex justify-between items-end transition hover:text-hell-black-60"
        @click="isShowDiscounts = !isShowDiscounts"
      >
        Скидки
        <SvgoChevronDown
          :class="{ 'rotate-180': isShowDiscounts }"
          class="self-end ml-0.5"
          filled
        />
        <span class="filler-underline" />
        <span>-{{ totalDiscountSum }} ₽</span>
      </button>

      <FoldableBlock v-model="isShowDiscounts">
        <div class="flex flex-col w-full gap-2 pt-3 pl-5">
          <div
            v-for="discount in discountsList"
            :key="discount.title"
            class="flex justify-between items-end"
          >
            <div>{{ discount.title }}</div>
            <div class="filler-underline" />
            <div>-{{ discount.value }} ₽</div>
          </div>
        </div>
      </FoldableBlock>
    </div>

    <div class="flex justify-between items-end">
      <div class="font-bold">Итого к оплате</div>
      <div class="filler-underline" />
      <div class="text-xl leading-none font-bold">{{ totalSum }} ₽</div>
    </div>
  </div>

  <div
    v-else
    class="text-xs text-hell-black-60 block md:hidden"
  >
    Выберите товары, чтобы перейти к оформлению заказа
  </div>
</template>
